"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addCache = exports.getCached = exports.parseResult = exports.extendedFetch = void 0;
function extendedFetch(url, settings, headerBuilders) {
    return __awaiter(this, void 0, void 0, function () {
        var defaultSettings, _i, headerBuilders_1, builder, headers, combinedSettings;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    defaultSettings = {
                        method: "GET",
                        mode: 'cors',
                        headers: new Headers({
                            'Content-Type': 'application/json',
                        })
                    };
                    if (!(headerBuilders !== undefined && headerBuilders !== null && headerBuilders.length)) return [3 /*break*/, 4];
                    _i = 0, headerBuilders_1 = headerBuilders;
                    _a.label = 1;
                case 1:
                    if (!(_i < headerBuilders_1.length)) return [3 /*break*/, 4];
                    builder = headerBuilders_1[_i];
                    return [4 /*yield*/, builder()];
                case 2:
                    headers = _a.sent();
                    headers.forEach(function (value, key) {
                        defaultSettings.headers.append(key, value);
                    });
                    _a.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4:
                    combinedSettings = __assign(__assign({}, defaultSettings), settings);
                    return [2 /*return*/, fetch(url, combinedSettings)];
            }
        });
    });
}
exports.extendedFetch = extendedFetch;
function parseResult(response, parse, shouldParse) {
    return __awaiter(this, void 0, void 0, function () {
        var json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(shouldParse || defaultShouldParse)(response)) return [3 /*break*/, 2];
                    return [4 /*yield*/, response.json()];
                case 1:
                    json = _a.sent();
                    return [2 /*return*/, {
                            statusCode: response.status,
                            error: json.error || null,
                            validationErrors: json.validationErrors || {},
                            success: json.success || false,
                            result: (parse || defaultParse)(json.result)
                        }];
                case 2: return [2 /*return*/, {
                        statusCode: response.status,
                        error: null,
                        success: false,
                        validationErrors: {},
                        result: null
                    }];
            }
        });
    });
}
exports.parseResult = parseResult;
function getCached(key) {
    if (sessionStorage) {
        var cached = sessionStorage.getItem(key);
        if (cached !== null) {
            try {
                var item = JSON.parse(cached);
                if (new Date(item.expiry) > new Date()) {
                    return item.item;
                }
                sessionStorage.removeItem(key);
            }
            catch (_a) {
                sessionStorage.removeItem(key);
            }
        }
    }
    return null;
}
exports.getCached = getCached;
function addCache(key, item, cacheMins) {
    if (sessionStorage) {
        var cached = { expiry: new Date(new Date().getTime() + ((cacheMins || 5) * 60000)), added: new Date(), item: item };
        sessionStorage.setItem(key, JSON.stringify(cached));
    }
}
exports.addCache = addCache;
function defaultParse(json) {
    return json;
}
function defaultShouldParse(response) {
    return response.status === 200;
}
